import { Container, Grid, makeStyles, Typography } from "@material-ui/core";
import successIcon from "../../assets/images/onboarding/success.svg";

const useStyles = makeStyles((theme) => ({
  title: {
    marginTop: theme.spacing(15),
  },
  subTitle: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(6),
  },
  img: {
    marginBottom: theme.spacing(8),
  },
}));
export const PortfolioSuccess = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="sm">
      <Grid container direction="column" alignItems="center">
        <Typography className={classes.title} variant="h4" align="center">
          Great!
        </Typography>
        <Typography
          className={classes.subTitle}
          variant="subtitle1"
          align="center"
        >
          You are getting closer to generating revenue from your Power while
          saving the planet from Carbon
        </Typography>
        <img className={classes.img} src={successIcon} alt="success-icon" />
      </Grid>
    </Container>
  );
};
